module.exports = __webpack_public_path__ + "img/clients-slider-bg.846d7af9.png";